import { useSearchCardsContext } from '@sorare/core/src/contexts/searchCards';
import { VIRTUAL_TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

import { useFormatFilterWidgetValue } from '#src/hooks/search/useFormatFilterWidgetValue/index.tsx';
import { FilterChip } from '#src/search/ActiveFilters/FilterChip/index.tsx';

export const VirtualToggleActiveFilters = ({
  setVirtualToggleFilters,
}: {
  setVirtualToggleFilters: (virtualToggle: {
    [name: string]: string | string[] | boolean | undefined;
  }) => void;
}) => {
  const {
    favoriteFilter,
    notInLineUpFilter,
    competitionEligibilityFilter,
    customDecksFilter,
    gameweekFilter,
    dailyFilter,
    probablePitchersFilter,
    promotionalEvent,
    watchlistFilter,
  } = useSearchCardsContext();
  const { formatFilterWidgetValue } = useFormatFilterWidgetValue();

  const virtualToggleFilters = [
    {
      filter: VIRTUAL_TOGGLE_FILTERS.gameweekFilter,
      condition: gameweekFilter,
      value: gameweekFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.dailyFilter,
      condition: dailyFilter,
      value: dailyFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.probablePitchersFilter,
      condition: probablePitchersFilter,
      value: probablePitchersFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.favoriteFilter,
      condition: false,
      value: favoriteFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.notInLineupFilter,
      condition: notInLineUpFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.competitionEligibilityFilter,
      condition: competitionEligibilityFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.customDecksFilter,
      condition: customDecksFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.promotionalEventFilter,
      condition: promotionalEvent,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.watchlistFilter,
      condition: watchlistFilter,
    },
  ];

  return (
    <>
      {virtualToggleFilters
        .filter(({ condition }) => !!condition)
        .map(virtualToggle => {
          const labels = formatFilterWidgetValue(virtualToggle.filter);
          return labels.map((label, index) => (
            <FilterChip
              key={typeof label === 'string' ? label : index}
              label={label}
              onClose={() => {
                setVirtualToggleFilters({
                  [virtualToggle.filter.name]:
                    virtualToggle.filter.defaultValue,
                });
              }}
            />
          ));
        })}
    </>
  );
};
